"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanelMenuItemsDesktop = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
function TabPanelMenuItemsDesktop(props) {
    var tabs = props.tabs, _a = props.activeIndex, activeIndex = _a === void 0 ? 0 : _a, onTabClick = props.onTabClick;
    return ((0, jsx_runtime_1.jsx)("div", { className: "components-tab-panel__tabs show-on-desktop", children: tabs.map(function (tab, index) {
            var icon = tab.icon, onClick = tab.onClick;
            var className = [
                'components-tab-panel__tabs-item',
                index === activeIndex ? 'is-active' : ''
            ].join(' ');
            return ((0, jsx_runtime_1.jsx)("div", { className: className, onClick: function () {
                    onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(index);
                    onClick === null || onClick === void 0 ? void 0 : onClick();
                }, children: (0, jsx_runtime_1.jsxs)("span", { children: [icon !== null && icon !== void 0 ? icon : null, " ", tab.title] }) }, index));
        }) }));
}
exports.TabPanelMenuItemsDesktop = TabPanelMenuItemsDesktop;
